import ProductWidgetContainer from "./ProductWidgetContainer";
import styled from "styled-components/macro";
import DraftNumberInput from "../../../inputs/DraftNumberInput";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const LLMGatewayProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: {
  product: ProductOptionInterface;
  onRemove: () => void;
  onProductChange: (updatedProduct: ProductOptionInterface) => void;
  editable: boolean;
  baselineProfile: string;
  deploymentType: string;
}) => {
  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product?.name}
      productKey={product.key}
      canBeRemoved={product?.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <FlexSection>
        <DraftNumberInput
          label="Concurrent Requests"
          product={product}
          field="concurrentRequests"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
        <DraftNumberInput
          label="Prompt Token Size"
          product={product}
          field="promptTokenSize"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
        <DraftNumberInput
          label="Pages Per Minute (Context Grounding)"
          product={product}
          field="pagesPerMinute"
          baselineProfile={baselineProfile}
          editable={editable}
          onProductChange={onProductChange}
        />
      </FlexSection>
    </ProductWidgetContainer>
  );
};

export default LLMGatewayProductWidget;
